<template>
    <router-view></router-view>
</template>

<script>
import bus from '../../../main';
import { BusinessesApi } from '@/api';

export default {
    name: 'Business',
    data() {
        return {
            isLoaded: true,
        };
    },
    async created() {
        const { data: business } = await BusinessesApi.get(this.$route.params.id);
        bus.$emit('load-business-event', business);
        this.isLoaded = true;
    },
};
</script>
